import { render } from "./VButton.vue?vue&type=template&id=425893a7&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"

import "./VButton.vue?vue&type=style&index=0&id=425893a7&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425893a7"]])

export default __exports__